import Text from 'components/_UI/Text';
import NotResultDashBoard from 'components/commons/NotResultDashBoard';
import React from 'react'
import { BarChart2 } from 'lucide-react';
import styled from 'styled-components';
import colors from 'theme/colors';

export default function FinancialAnalysis() {
    return (
        <Container>
            <SectionHeader>
                <SectionIcon>
                    <BarChart2 size={18} color={colors.occasionalPurple} />
                </SectionIcon>
                <HeaderContent>
                    <Text type='bold' color={colors.nightDark} paddingBottom={0}>
                        Análises
                    </Text>
                    <Text name='small' color={colors.night} paddingBottom={0}>
                        Relatórios e insights financeiros
                    </Text>
                </HeaderContent>
            </SectionHeader>

            <ContentNotResult>
                <NotResultDashBoard
                    text={
                        <Text name='subtitle'>
                            Em breve...
                        </Text>
                    }
                    ilustration={'analysis'}
                    marginTop={'15px'}
                />
            </ContentNotResult>
        </Container>
    )
}

const Container = styled.div`
    background: ${colors.neutralLight};
    border: 1px solid ${colors.neutralDark};
    border-radius: 12px;
    padding: 20px;
    margin-top: 10px;
`;

const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
`;

const SectionIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #F3EAFF;
    flex-shrink: 0;
`;

const HeaderContent = styled.div`
    flex: 1;
`;

const ContentNotResult = styled.div`
    & > div {
        flex-direction: column;
    }

    & > div > picture {
        width: 45%;
    }

    & > div > div {
        width: 100%;
    }
`;